import { useState } from 'react';
import './NewsletterSignup.css';

export default function NewsletterSignup() {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', isError: false });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage({ text: '', isError: false });

    try {
      // Call your backend API endpoint instead of Brevo directly
      const response = await fetch(`${process.env.REACT_APP_FUTSAL_DIRECTORY_API_URL}/api/brevo/subscribe`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // Add authentication header if your API requires it
          // 'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          email,
          name
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Subscription failed');
      }

      setMessage({ text: 'Thank you for subscribing!', isError: false });
      setEmail('');
      setName('');
    } catch (error) {
      console.error('Subscription error:', error);
      setMessage({ 
        text: error.message || 'Subscription failed. Please try again later.', 
        isError: true 
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="newsletter-signup">
      <h3>Join Our Newsletter</h3>
      <form onSubmit={handleSubmit} className='newletter-form'>
        <input
          type="text" 
          id="firstName" 
          name="firstName" 
          autocomplete="given-name" 
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Your name"
          required
        />
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Your email"
          required
        />
        <button type="submit" disabled={isLoading}>
          {isLoading ? 'Submitting...' : 'Subscribe'}
        </button>
      </form>
      {message.text && (
        <div className={`message ${message.isError ? 'error' : 'success'}`}>
          {message.text}
        </div>
      )}
    </div>
  );
}